export default "__VITE_ASSET__Cdusumgj__"